<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2"><span class="text_">John E. Patten was born in the Docklands area of South London in 1940.</span><span class="text_1"> </span><span class="text_">A potential literary career could have ended when Hitler bombed the Hospital.</span><span class="text_1"> </span><span class="text_">His schooling took place in the East End and Boys Brigade Camps gave him a taste of life outside the capital. John was the first of his family to go onto higher education at Bishop Otter College, Chichester. He taught primary schools in West Sussex, Hampshire, Essex and North Yorkshire and became a head teacher in Cheshire for 24 years before retirement. John is married to a retired teacher and has one daughter who declined any suggestion of entering the profession.</span></p>
<p class="block_3" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?f3385594